// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

interface Props {
  formValues: any;
  onReset: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
/**
 * Function to create a React Component component
 *
 * @param props component properties
 * @returns react node component
 */
function ButtonsForm(props: Props): JSX.Element {
  return (
    <fieldset>
      <footer>
        <div className="text-right">
          <label>
            <i>This field is required (*)</i>
          </label>
        </div>
        <div className="text-right">
          {props.formValues.loading && (
            <img className="loading-wdna" alt="loading" src="assets/img/loading-wdna.gif" />
          )}

          <button type="button" onClick={props.onReset} className="btn btn-primary">
            Reset
          </button>

          <button type="submit" className="btn btn-primary">
            Save
          </button>
        </div>
      </footer>
    </fieldset>
  );
}

export default ButtonsForm;
